import { render, staticRenderFns } from "./sm.vue?vue&type=template&id=39095cef&lang=pug&"
import script from "./sm.vue?vue&type=script&lang=js&"
export * from "./sm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports